import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11798e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-page" }
const _hoisted_2 = { class: "single-page-img-box touch-dom" }
const _hoisted_3 = ["src", "alt", "onClick"]
const _hoisted_4 = {
  id: "canvas-cut",
  width: "1920",
  height: "1080"
}
const _hoisted_5 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("目录列表"),
    _createVNode($setup["chapterListMenu"], {
      onBefore: $setup.before,
      onNext: $setup.next,
      onChangeChapter: $setup.change_chapter
    }),
    _createCommentVNode("功能菜单"),
    _createVNode($setup["rightSidebar"], { onDwonload: $setup.dwonload_image }),
    _createCommentVNode("图片容器"),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["bookmark"], {
        page: $setup.page,
        chapterId: $setup.chapterInfo.chapterId
      }, null, 8 /* PROPS */, ["page", "chapterId"]),
      _createElementVNode("img", {
        class: "single-page-img",
        src: $setup.imgSrc,
        alt: $setup.t('browse.imgLoadError'),
        onClick: _withModifiers($setup.switch_menu, ["stop"])
      }, null, 8 /* PROPS */, _hoisted_3),
      _createVNode($setup["operationCover"], {
        onBefore: $setup.beforePage,
        onNext: $setup.nextPage,
        onSwitchMenu: $setup.switch_menu,
        onSwitchFooter: $setup.switch_footer
      })
    ]),
    _createCommentVNode(" 隐藏的canvas容器 "),
    _withDirectives(_createElementVNode("canvas", _hoisted_4, null, 512 /* NEED_PATCH */), [
      [_vShow, false]
    ]),
    _createCommentVNode(" 页码显示 "),
    _createVNode($setup["pageNumber"], {
      page: $setup.page,
      count: $setup.count
    }, null, 8 /* PROPS */, ["page", "count"]),
    _createCommentVNode("分页按钮"),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        class: "btn",
        type: "warning",
        plain: "",
        onClick: $setup.before
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.before')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["browsePager"], {
        ref: "pager",
        onPageChange: $setup.page_change,
        onReloadPage: $setup.reload_page,
        page: $setup.page,
        count: $setup.count
      }, null, 8 /* PROPS */, ["page", "count"]),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "success",
        plain: "",
        onClick: $setup.next
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.next')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.config.browseFooter]
    ])
  ]))
}